import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CheckOutlined } from '@mui/icons-material';
import {
  RequiredFieldItemsWrapper,
  RequiredFieldsChip,
  RequiredFieldsHelpDescription,
  RequiredFieldsNoFieldsWrapper,
  RequiredFieldsTitle,
  RequiredFieldsWrapper
} from './OfferAssetStyles';
import { Typography } from '@totalsoft/rocket-ui';
import WrappedFakeText from 'components/common/WrappedFakeText';

const OfferAssetRequiredPropertiesComponent = ({ properties, handleClickToScroll, assetPropertiesAreLoaded }) => {
  const { t } = useTranslation();
  const [showAllProperties, setShowAllProperties] = useState(false);
  const isWidthLarge = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const maxDisplayedProperties = properties.length ? (isWidthLarge ? 10 : 3) : 0;
  const numberOfHiddenProperties = properties.length - maxDisplayedProperties;
  const allFieldsAreFilled = maxDisplayedProperties === 0;
  const hasErrors = !allFieldsAreFilled || !assetPropertiesAreLoaded;

  const handleClick = () => {
    setShowAllProperties(!showAllProperties);
  };

  return (
    <RequiredFieldsWrapper hasErrors={hasErrors}>
      <Grid container spacing={2}>
        <RequiredFieldsTitle item xs={12} hasErrors={hasErrors}>
          {t('OfferEdit.Asset.RequiredFields.Title').toUpperCase()}
        </RequiredFieldsTitle>
        {!assetPropertiesAreLoaded && !properties.some(p => p.name === 'Asset') ? (
          <Grid container item>
            <WrappedFakeText lines={4} />
          </Grid>
        ) : (
          <RequiredFieldItemsWrapper container item>
            {allFieldsAreFilled ? (
              <RequiredFieldsNoFieldsWrapper>
                <CheckOutlined color='success' />
                {t('OfferEdit.Asset.RequiredFields.NoEmptyFields')}
              </RequiredFieldsNoFieldsWrapper>
            ) : (
              properties.map((prop, index) =>
                showAllProperties || index < maxDisplayedProperties ? (
                  <RequiredFieldsChip key={index} label={prop.name} onClick={() => handleClickToScroll(prop.name)} color='error' />
                ) : (
                  ''
                )
              )
            )}
          </RequiredFieldItemsWrapper>
        )}
        {numberOfHiddenProperties > 0 && (
          <Grid item lg={12}>
            <div onClick={handleClick}>
              {!showAllProperties
                ? t('OfferEdit.Asset.RequiredFields.ExtraFields', { data: numberOfHiddenProperties })
                : t('OfferEdit.Asset.RequiredFields.ShowLess')}
            </div>
          </Grid>
        )}
        {!allFieldsAreFilled && (
          <Grid item xs={12}>
            <Typography variant='subtitle1' fontWeight='bold'>
              {t('OfferEdit.Asset.RequiredFields.Help.Title')}
            </Typography>
            <RequiredFieldsHelpDescription>{t('OfferEdit.Asset.RequiredFields.Help.Description')}</RequiredFieldsHelpDescription>
          </Grid>
        )}
      </Grid>
    </RequiredFieldsWrapper>
  );
};

OfferAssetRequiredPropertiesComponent.propTypes = {
  properties: PropTypes.array.isRequired,
  handleClickToScroll: PropTypes.func.isRequired,
  assetPropertiesAreLoaded: PropTypes.bool.isRequired
};

export default OfferAssetRequiredPropertiesComponent;
